import { IWorkflowAction } from '@/shared/IWorkflowAction';
import { Box, Button, Container, Slide, Stack, Text } from '@chakra-ui/react'
import React from 'react';
import { ActionList } from '../course/ActionList';
import { ICourse } from '@/shared/ICourse';
import { ICourseModule } from '@/shared/ICourseModule';

export const ReadOnlyNotice = (props: {
  course: ICourse;
  module: ICourseModule;
  actions: IWorkflowAction[];
  onCourseChanged?: (course: ICourse) => void;
}) => {

  const [isOpen, setIsOpen] = React.useState(true);

  return (
    <Slide style={{ zIndex: 1450 }} direction='bottom' in={isOpen}>
      <Container bg='white' px={{ base: '0', md: '6' }}>
        <Box borderTopRadius={{ base: '0', md: 'lg' }} borderColor='brand.500' borderWidth="1px" borderBottomWidth="0" bg='brand.50' boxShadow="sm">
          <Box px="4" py={{ base: '4', md: '3.5' }}>
            <Stack spacing="4" justify={{ base: 'start', md: 'space-between' }} direction={{ base: 'column', md: 'row' }}>
              <Box mb='2'>
                <Text fontWeight='bold'>Read-Only Mode</Text>
                <Text>The questionnaire is opened as read-only. {props.actions.length > 0 && <span>To make changes, please start edit/review.</span>}</Text>
              </Box>
              <Stack
                direction={{ base: 'column', md: 'row' }}
                spacing="3"
                align={{ base: 'stretch', md: 'center' }}
              >
                <ActionList course={props.course} moduleId={props.module.id} actions={props.actions} onCourseChanged={props.onCourseChanged} />
                <Button variant="outline" onClick={() => setIsOpen(false)}>Dismiss</Button>
              </Stack>
            </Stack>
          </Box>
        </Box>
      </Container>
    </Slide>
  )
}